import { MediaViewer } from '@atlassian/mpac-primitives';
import { UserGeneratedHtml } from '@atlassian/mpac-ui';
import React, { useCallback, useState } from 'react';
import { TEST_ID } from '../../../../../constants';
import Image from '../../../../Image';
import FallbackInstallationDocumentation from '../FallbackInstallationDocumentation';
import { InstallationStepItem as Item, InstallationStepsList as List } from '../styles';
import { InstallationScreenshotContainer } from './styles';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const getInstructionMediaItem = instruction => instruction.screenshot ? {
  dataURI: instruction.screenshot.url,
  name: instruction.instruction
} : null;
const getMediaItems = instructions => {
  return instructions.map(instruction => getInstructionMediaItem(instruction)).filter(instruction => instruction !== null);
};
const InstructionalAppInstallationSteps = props => {
  const {
    instructions,
    appName,
    documentationUrl
  } = props;
  const [activeMedia, setActiveMedia] = useState(null);
  const handleMediaViewerClose = useCallback(() => setActiveMedia(null), []);
  const handleMediaItemSelect = useCallback(instruction => {
    setActiveMedia({
      dataURI: instruction.screenshot,
      name: instruction.instruction
    });
  }, []);
  if (!instructions.length) {
    return /*#__PURE__*/_jsx(FallbackInstallationDocumentation, {
      appName: appName,
      documentationUrl: documentationUrl
    });
  }
  return /*#__PURE__*/_jsxs(List, {
    children: [activeMedia && /*#__PURE__*/_jsx(MediaViewer, {
      mediaItems: getMediaItems(instructions),
      selectedMediaItem: activeMedia,
      onClose: handleMediaViewerClose
    }), instructions.map((instruction, index) => {
      const {
        instruction: content,
        screenshot
      } = instruction;
      return /*#__PURE__*/_jsxs(Item, {
        children: [/*#__PURE__*/_jsx(UserGeneratedHtml, {
          dangerousHtml: content
        }), screenshot && /*#__PURE__*/_jsx(InstallationScreenshotContainer, {
          children: /*#__PURE__*/_jsx(Image, {
            image: screenshot,
            "data-testid": TEST_ID.INSTALLATION_TAB_STEP_SCREENSHOT,
            onClick: () => handleMediaItemSelect({
              instruction: content,
              screenshot: screenshot.url
            })
          })
        })]
      }, "".concat(content, "-").concat(index));
    })]
  });
};
export default InstructionalAppInstallationSteps;